import { Component, OnInit } from '@angular/core';
import {DatePipe, DecimalPipe} from '@angular/common';
import {BsModalService} from 'ngx-bootstrap';
import {ApiService, ExcelService} from "../../../../../projects/accounting/src/public_api";
import {PointPurchaseDetailComponent} from './point-purchase-detail/point-purchase-detail.component';
import {PointUsedDetailComponent} from './point-used-detail/point-used-detail.component';
@Component({
  selector: 'app-aha-point',
  templateUrl: './aha-point.component.html',
  styleUrls: ['./aha-point.component.scss']
})
export class AhaPointComponent implements OnInit {
  data: any = null;
  period: string = null;
  nextPeriod = null;
  loading = false;
  senders: any = null;

  public dtConfig: any = null;
  constructor(
      private api: ApiService,
      private decimal: DecimalPipe,
      private date: DatePipe,

      private bsModalService: BsModalService
  ) {
  }

  ngOnInit() {
    this.load();
  }
  load(){
    if(this.period == null){
      return;
    }
    this.loading = true;
    // Bought: 0
    // Date: "01-03-2020"
    // Fee: 0
    // Used: 0
    this.api.pointHistory(this.period).subscribe( rs => {
      if(rs.succeed){
          rs.data= rs.data.filter(i => i.Bought > 0 || i.Used > 0);
        this.dtConfig = this.createUI(rs.data);
      }
      this.loading = false;
    })
  }

  createUI(data: Array<any>){

    return {
      data: data,
      title: 'THỐNG KÊ THÔNG TIN MUA, ĐỔI ĐIỂM AHA POINT',
      columns: [
        {
          title: 'Ngày',
          html: function (i) {
            return '<b>' + i.Time + '</b>';
          },

        },
        {
          title: 'Mua đối soát',
          class: 'text-right',
          html: i => i.Bought > 0 ? this.decimal.transform(i.Bought - i.Cash, '1.0-0', 'en-US') : 0,
          css: i => 'text-right text-success',
          click: i => {
            if(i.Bought > 0) {
              this.viewDetail(i, 'purchase')
            }
          }
        },
        {
          title: 'Mua tiền mặt',
          class: 'text-right',
          html: i => i.Bought > 0 ? this.decimal.transform(i.Cash, '1.0-0', 'en-US') : 0,
          css: i => 'text-right text-success',
          click: i => {
            if(i.Bought > 0) {
              this.viewDetail(i, 'purchase')
            }
          }
        },
        {
          title: 'Tổng mua',
          class: 'text-right',
          html: i => i.Bought > 0 ? this.decimal.transform(i.Bought, '1.0-0', 'en-US') + '<br>' + '<i class="text-primary"><small>Chi tiết</small></i>' : 0,
          css: i => 'text-right text-success',
          click: i => {
            if(i.Bought > 0) {
              this.viewDetail(i, 'purchase')
            }
          }
        },
        {
          title: 'Phí',
          class: 'text-right',
          html: i => this.decimal.transform(i.Fee, '1.0-0', 'en-US'),
          css: i => 'text-right text-danger',
        },
        {
          title: 'Tiền sử dụng',
          class: 'text-right',
          html: i => i.Used > 0 ? this.decimal.transform(i.Used, '1.0-0', 'en-US') + '<br>' + '<i class="text-primary"><small>Chi tiết</small></i>' : 0,
          css: i => 'text-right text-warning',
          click: i => {
            if(i.Used > 0){
              this.viewDetail(i, 'used')
            }
          }

        }

      ],

      footer: data => {
        let pgw = 0;
        let pc = 0;
        let pb = 0;
        let pf = 0;
        let pu = 0;
        data.forEach(i => {
          pgw += (i.Bought - i.Cash);
          pc += i.Cash;
          pb += i.Bought;
          pf += i.Fee;
          pu += i.Used;
        });

        return [
          {html: '<b>TỔNG</b>'},
          {html: this.decimal.transform(pgw, '1.0-0', 'en-US'), class: 'text-right text-success'},
          {html: this.decimal.transform(pc, '1.0-0', 'en-US'), class: 'text-right text-success'},
          {html: this.decimal.transform(pb, '1.0-0', 'en-US'), class: 'text-right text-success'},
          {html: this.decimal.transform(pf, '1.0-0', 'en-US'), class: 'text-right text-danger'},
          {html: this.decimal.transform(pu, '1.0-0', 'en-US'), class: 'text-right text-warning'},
        ];
      }
    }

  }

  viewDetail(i, type){
    if(type != 'used'){
      this.bsModalService.show(PointPurchaseDetailComponent, {
        class: 'modal-lg',
        initialState: {
          time: i.Time
        }
      })
    }else{
      this.bsModalService.show(PointUsedDetailComponent, {
        class: 'modal-lg',
        initialState: {
          time: i.Time
        }
      })
    }

  }
}
